import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const Wrap = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}));

export const Head = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '10px',
}));

export const Name = styled(Typography)(() => ({
  fontSize: '17px',
  fontWeight: 700,
  color: protoColors.textPrimary,
}));

export const Sub = styled(Typography)(() => ({
  fontSize: '13px',
  color: protoColors.textMuted,
}));

export const MetricRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '13.5px',
  padding: '6px 0',
  borderBottom: `1px solid ${protoColors.surfaceSubtle}`,
}));

export const MetricLabel = styled('span')(() => ({
  color: protoColors.textMuted,
}));

export const MetricValue = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color }) => ({
  fontWeight: 700,
  color: color ?? protoColors.textPrimary,
}));

export const Block = styled(Box)(() => ({
  fontSize: '13px',
  color: protoColors.textPrimary,
}));

export const BlockLabel = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  color: protoColors.textMuted,
  marginBottom: '4px',
}));

export const Reason = styled(Box)(() => ({
  fontSize: '12.5px',
  color: protoColors.danger,
  backgroundColor: `${protoColors.danger}12`,
  borderRadius: '8px',
  padding: '6px 10px',
  marginTop: '4px',
}));

export const EmptyHint = styled(Typography)(() => ({
  fontSize: '13px',
  color: protoColors.textMuted,
  textAlign: 'center',
  padding: '24px 0',
}));
